<div class="upload-container">
  <!-- Visibility toggle -->
  <div class="visibility-toggle">
    <span class="toggle-label">
      {{ "COMPONENTS.MEDIA_LIBRARY.UPLOAD.VISIBILITY.LABEL" | translate }}
    </span>
    <div class="toggle-options">
      <button
        mat-button
        class="toggle-btn"
        [class.active]="visibility === 'private'"
        (click)="visibility = 'private'; onVisibilityChanged()"
      >
        <mat-icon>lock</mat-icon>
        {{ "COMPONENTS.MEDIA_LIBRARY.UPLOAD.VISIBILITY.PRIVATE" | translate }}
      </button>
      <button
        mat-button
        class="toggle-btn"
        [class.active]="visibility === 'public'"
        (click)="visibility = 'public'; onVisibilityChanged()"
      >
        <mat-icon>public</mat-icon>
        {{ "COMPONENTS.MEDIA_LIBRARY.UPLOAD.VISIBILITY.PUBLIC" | translate }}
      </button>
    </div>
    <mat-icon
      class="help-icon"
      matTooltip="{{ 'COMPONENTS.MEDIA_LIBRARY.UPLOAD.VISIBILITY.TOOLTIP' | translate }}"
    >help_outline</mat-icon>
  </div>

  <!-- Drop zone -->
  <div
    class="drop-zone"
    [class.drag-over]="dragOver"
    ngFileDrop
    [options]="options"
    (uploadOutput)="onUploadOutput($event)"
    [uploadInput]="uploadInput"
  >
    <mat-icon class="drop-icon">cloud_upload</mat-icon>
    <span class="drop-label">
      {{ "COMPONENTS.MEDIA_LIBRARY.UPLOAD.DROP_AREA" | translate }}
    </span>
    <span class="drop-hint">
      {{ mediaType === 'photos' ? 'JPG, PNG' : 'MP4, AVI, MOV' }}
    </span>
  </div>

  <!-- Upload button -->
  <label class="upload-btn">
    <input
      ngFileSelect
      type="file"
      [options]="options"
      (uploadOutput)="onUploadOutput($event)"
      [uploadInput]="uploadInput"
    />
    <mat-icon>file_upload</mat-icon>
    <span>{{ "COMPONENTS.MEDIA_LIBRARY.UPLOAD.UPLOAD_BUTTON" | translate }}</span>
  </label>

  <!-- Status message -->
  <div class="status-message" *ngIf="statusMessage">
    <mat-icon>warning</mat-icon>
    <span>{{ statusMessage }}</span>
  </div>
</div>
